'use client';

import Image from 'next/image';
import Link from 'next/link';
import { BackButton } from './back-button';
import { useBackButton } from './back-button-context';

export function NavHeader() {
  const { showBackButton, backButtonFallback } = useBackButton();

  return (
    <div className="flex gap-3 items-center h-full py-1">
      {showBackButton && (
        <BackButton fallbackUrl={backButtonFallback} />
      )}
      <h1 className="h-full">
        <Link href="/" className="block h-full">
          <img
            src="/logos/logo-light.svg"
            alt="StarkyTranslate"
            className="h-full w-auto dark:hidden transition-transform duration-300 hover:scale-125 hover:-rotate-6"
          />
          <img
            src="/logos/logo-dark.svg"
            alt="StarkyTranslate"
            className="h-full w-auto hidden dark:block transition-transform duration-150 hover:scale-125 hover:-rotate-6"
          />
        </Link>
      </h1>
    </div>
  );
}
